import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import IconButton from '@mui/material/IconButton';

import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';


import TableCell  from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import { formatDate,  } from '../utils/utils';
import ChipLabel from './ChipLabel';

import amexLogo from '../assets/amexLogo.svg'
import masterCardLogo from '../assets/masterCardLogo.svg'
import visaLogo from '../assets/visaLogo.svg'
import mercadoPagoLogo from '../assets/mercadoPagoLogo.svg'
import { chipStatus } from '../utils/enums';

const tableStyle = {
  headerCell: {
    color: '#A1A1A1', 
    borderBottom: '0', 
    padding: {xs:'0.5rem 0.25rem', md: '0.5rem 0.5rem'},
    fontSize:'0.8125rem',
    width:{xs: '25%', md: '18%'}
  },
  headerRow:{
    borderBottom:'1px solid #A1A1A1'
  },
  bodyCell:{
    padding: '1rem 0.5rem',
    width:{xs: '25%', md: '20%'},
    borderBottom: '1px solid #F8F8F8',
    maxWidth: 0
  },
  preventOverflow: {
    whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
  },
  twoLinesOverflow: {
    fontSize: {xs: '0.875rem', lg: '1rem'}, display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden'
  },
  pagination:{
    fontSize: '0.875rem',
    color: '#303030'
  },
  iconPagination: {
    padding: 0,
    color:'#303030'
  },
  SelectOptions:{
    fontSize: {xs:'0.875rem', md:'1rem'}
  },
  pageNumber: {
    padding: {xs:'0.469rem 3.217rem', md: '0.688rem 1.155rem'},
    borderRadius: '0.25rem',
    border: '1px solid #D9D9D9',
    background: '#FFFEFC',
    fontSize:'1rem'
  }
};

const LogoListConverter  = {
  visa: visaLogo,
  debvisa: visaLogo,
  master: masterCardLogo,
  debmaster: masterCardLogo,
  amex: amexLogo,
  account_money: mercadoPagoLogo,
};

export default function DataTableOrders({
  tableData = [],
  onEdit,
  onDelete,
  onVariants,
  page, 
  rowsPerPage,
  totalPages,
  onPageChange,
  onRowsPerPageChange,
  isLoading
}) {

  const [rows, setRows] = React.useState([]);
  
  React.useEffect( () => {
    setRows(tableData);
  },[tableData]);


  const handleModal = (item) => {
    onEdit(item);
  };

  const handleBackButton = () => {
    onPageChange(page - 1);
  };

  const handleNextButton = () => {
    onPageChange(page + 1);
  };

  const handleRowsPerPageChange = (evt) => {
    onRowsPerPageChange(evt.target.value);
  };

  return (
    <>
      <TableContainer sx={{display:'block' }} component={Paper}>
        <Table sx={{ minWidth: 500 }}>
          <TableHead>
            <TableRow sx={tableStyle.headerRow}>
              <TableCell sx={tableStyle.headerCell} align="center">NO. DE ORDEN</TableCell>
              <TableCell sx={tableStyle.headerCell} align="center">FECHA</TableCell>
              {/* <TableCell sx={{...tableStyle.headerCell, display: {xs:'none', md: 'table-cell'}}} align="center">EMPAQUETADO</TableCell> */}
              <TableCell sx={tableStyle.headerCell} align="center">ESTADO DE ORDEN</TableCell>
              <TableCell sx={{...tableStyle.headerCell, display: {xs:'none', md: 'table-cell'}}} align="center">MÉTODO DE PAGO</TableCell>
              <TableCell sx={tableStyle.headerCell} align="center">TOTAL</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
          {(rows).map((row) => {
            // console.log("ROW", row);
            
            const logo = LogoListConverter[row.paymentMethod];
            return (
              <TableRow hover key={row._id} sx={{cursor: 'pointer'}} onClick={() => handleModal(row)} >
                <TableCell sx={tableStyle.bodyCell} align="center">
                  <Box sx={{display:'flex', flexDirection:'column', justifyContent:'center', alignItems: 'center', gap: '0.5rem' }}>
                    <Typography sx={{color:'#303030', fontSize:{ xs:'0.875rem', lg: '1.125rem' }, fontWeight:'600', ...tableStyle.twoLinesOverflow }}>
                      {`No. ${row._id.split('-')[0]}`}
                    </Typography>
                    {/* <ChipLabel label={(chipStatus.pending).label} background={(chipStatus.pending).background} /> */}
                  </Box>
                </TableCell>
                <TableCell sx={tableStyle.bodyCell} align="center">
                  <Typography sx={tableStyle.twoLinesOverflow}>
                    {formatDate(row.paidAt)}
                  </Typography>
                </TableCell>
                {/* <TableCell sx={{...tableStyle.bodyCell, display:{xs:'none', md:'table-cell' } }} align="center">
                  <Typography sx={tableStyle.twoLinesOverflow}>
                    {!!row.isPackaged ? 'Si' : 'No'}
                  </Typography>
                </TableCell> */}
                <TableCell sx={tableStyle.bodyCell} align="center">
                  <Box sx={{display:'flex', justifyContent:'center'}}>
                  <ChipLabel label={(chipStatus[row.status]).label} background={(chipStatus[row.status]).background} />
                  </Box>
                </TableCell>
                <TableCell sx={{...tableStyle.bodyCell, display:{xs:'none', md:'table-cell' } }} align="center">
                  <Box sx={{display:'flex', justifyContent:'center'}}>
                    {logo ? <img src={logo} alt="logo" /> : ''}
                  </Box>
                </TableCell>
                <TableCell sx={tableStyle.bodyCell} align="center">
                  <Typography sx={tableStyle.twoLinesOverflow}>
                    {`$ ${row.totalPaid} MXN`}
                  </Typography>
                </TableCell>
              </TableRow>
            )}
          )}
            {rows.length == 0 && (
              <TableRow style={{ height: 53 }}>
                <TableCell colSpan={6} align='center' >
                  SIN DATOS
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {/* <Box sx={{display:{xs:'flex', lg:'none'}, flexDirection: 'column', gap:{xs:'0.63rem'} }}>
        {(rows).map( (row, index) => (
          <Box
          key={index}
            sx={{
              display: 'flex',
              padding: '0.75rem',
              alignItems: 'flex-start',
              gap: {xs:'0.5rem', md:'0.75rem'},
              height:'100%',
              alignItems: 'center',
              alignSelf: 'stretch',
              borderRadius: '0.25rem',
              background: '#FFF',
              boxShadow: '2px 4px 10px 0px rgba(0, 0, 0, 0.10)'
            }}
          >
            <Box 
              sx={{
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                gap: '1rem',
                flex: '1 0 0'
              }}
            >
              <Box sx={{ 
                display: 'flex',
                paddingBottom: '0.5rem',
                flexDirection: 'column',
                alignItems: 'flex-start',
                gap: '0.75rem',
                alignSelf: 'stretch',
                borderBottom: '1px solid #F8F8F8'
               }}>
                <Typography sx={{color: '#252323', fontSize: {xs:'0.875rem', md:'1rem'}, fontWeight: '700', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', width:'100%' }}> {row.characteristicName} </Typography>
              </Box>
              <Box sx={{color: '#252323', fontSize:'0.875rem' }}>
                <Typography 
                  sx={{
                    display: '-webkit-box',
                    WebkitLineClamp: 2, 
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                  }}
                >
                  {row.values.map(value => value.valueName).join(', ')}
                </Typography>
              </Box>
              <Box sx={{display:'flex', justifyContent:'flex-end', gap: '1.5rem' }}>
                <Box sx={{display:'flex', gap:'1.25rem' }}>
                  <ActionsButton onEdit={onEdit} onDelete={onDeleteModal} onVariants={onVariants} rowItem={row}/>
                </Box>
              </Box>
            </Box>
          </Box>
        ))}
      </Box> */}
      <Box sx={{py:{xs:'1.5rem', md:'2rem'}, display:'flex', flexDirection: {xs:'column', sm: 'row'}, justifyContent:'space-between' }}>
        <Box>
          <Typography sx={{ display: {xs: 'block', sm: 'none' }, textAlign:'center', color: '#676565', pb:'1.2rem', fontSize: tableStyle.pagination.fontSize }}>{`Mostrando ${rows.length} resultados`}</Typography>
          <Select
            sx={{
              display:{xs:'none', sm:'inline-flex'},
              backgroundColor:'#FFFEFC', 
              fontSize: {xs:'0.875rem', md:'1rem'},
              '& .MuiSelect-select': {
                paddingRight: '0.75rem !important', 
              },
            }}
            IconComponent={() => <KeyboardArrowLeft sx={{transform: 'rotate(270deg)', mr: '0.75rem' }}/>}
            MenuProps={{
              MenuListProps:{
                fontSize: '5px'
              }
            }}
            value={rowsPerPage}
            onChange={handleRowsPerPageChange}
            disabled={isLoading}
          >
            <MenuItem sx={tableStyle.SelectOptions} value={25}>25 resultados</MenuItem>
            <MenuItem sx={tableStyle.SelectOptions} value={50}>50 resultados</MenuItem>
            <MenuItem sx={tableStyle.SelectOptions} value={75}>75 resultados</MenuItem>
            <MenuItem sx={tableStyle.SelectOptions} value={100}>100 resultados</MenuItem>
          </Select>
        </Box>
        <Box sx={{ display:'flex', alignItems:'center', gap:{xs:'0rem', sm:'0.5rem', md:'0.75rem'}, justifyContent:{xs: 'space-between', sm:'unset'} }}>
          <IconButton
            sx={tableStyle.iconPagination}
            onClick={handleBackButton}
            disabled={page === 1 || isLoading}
          >
            <KeyboardArrowLeft/>
          </IconButton>
          <Typography sx={tableStyle.pagination}>Página</Typography>
          <Typography sx={tableStyle.pageNumber}>{page}</Typography>
          <Typography sx={tableStyle.pagination}>{`de ${totalPages}`}</Typography>
          <IconButton
            sx={tableStyle.iconPagination}
            onClick={handleNextButton}
            disabled={page === totalPages || isLoading}
          >
            <KeyboardArrowRight/>
          </IconButton>
        </Box>
      </Box>
    </>
  );
}
